export default {
  "products.products": { en: "Products", fa: "محصول‌ها" },
  "products.add-product": { en: "Add Product", fa: "اضافه کردن محصول" },
  "products.name": {
    en: "Name",
    fa: "نام محصول"
  },
  "products.title": { en: "Title", fa: "تیتر" },
  "products.category": {
    en: "Category",
    fa: "دسته‌ بندی"
  },
  "products.made-in": {
    en: "Made In",
    fa: "ساختِ"
  },
  "products.weight": {
    en: "Weight",
    fa: "وزن"
  },
  "products.height": {
    en: "Height",
    fa: "ارتفاع"
  },
  "products.color": {
    en: "Color",
    fa: "رنگ"
  },
  "products.in-home": {
    en: "In Home",
    fa: "در خانه"
  },
  "products.active": {
    en: "Active",
    fa: "فعال"
  },
  "products.in-network": {
    en: "In Network",
    fa: "در شبکه"
  },
  "products.production-date": {
    en: "Production Date",
    fa: "تاریخ تولید"
  },
  "products.made-in-country": {
    en: "Made In Country",
    fa: "ساخت کشور"
  },
  "products.made-in-city": {
    en: "Made In City",
    fa: "ساخت شهر"
  },
  "products.properties": {
    en: "Properties",
    fa: "دسته بندی ها"
  },
  "products.no-property-found": {
    en: "This category doesn't have any property!",
    fa: "این دسته بندی هیچ خصوصیتی ندارد!"
  },
  "products.choose-category-first": {
    en: "Choose a category first!",
    fa: "ابتدا یک دسته بندی انتخاب کنید!"
  },
  "products.priority": {
    en: "Priority",
    fa: "اولویت"
  },
  "products.choose-images": {
    en: "Choose",
    fa: "انتخاب"
  },
};
